import React from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"

class GoBack extends React.Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
      replace: PropTypes.func.isRequired
    }).isRequired
  }

  componentDidMount = () => {
    this.props.history.goBack()
  }

  render = () => null
}

export default withRouter(GoBack)
